/**
 * Module-level bridge between MSAL (which lives in React context) and the
 * non-React modules that need a fresh access token — gateway.js's 401
 * refresh-and-retry and the walk-round pre-batch refresh.
 *
 * AuthContext registers a silent-only refresher once MSAL is initialized and
 * unregisters it on teardown. Fail-soft by contract: refreshAccessToken NEVER
 * throws — null means "no fresh token available" and callers fall back to the
 * existing 401 handling (session wipe + login redirect). Interaction-required
 * failures (e.g. AADSTS53003, Conditional Access blocking token issuance — the
 * 2026-08-20 walk-round incident) deliberately resolve null rather than
 * launching interactive auth from a background code path.
 */

let refresher = null;

export function registerTokenRefresher(fn) {
  refresher = fn;
}

export function unregisterTokenRefresher() {
  refresher = null;
}

export async function refreshAccessToken() {
  if (!refresher) return null;
  try {
    return (await refresher()) || null;
  } catch {
    return null;
  }
}
